'use client';

import CourseHeader from './course-header';
import VideoSection from './video-section';
import CourseDescription from './course-description';
import CourseGoals from './course-goals';
import CourseOutline from './course-outline';
import AssessmentCard from './assessment-card';
import DownloadableMaterials from './downloadable-materials';
import ProgressCard from './progress-card';
import courseData from './data/course-data';

export default function CoursePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <CourseHeader
        title={courseData.title}
        subtitle={courseData.subtitle}
        duration={courseData.stats.duration}
        students={courseData.stats.students}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Main Content */}
          <div className="lg:col-span-2 space-y-8">
            <VideoSection
              currentLesson={courseData.progress.currentLesson}
              currentLessonNumber={courseData.progress.currentLessonNumber}
              totalLessons={courseData.progress.totalLessons}
            />
            <CourseDescription description={courseData.description} />
            <CourseGoals goals={courseData.goals} />
            <CourseOutline modules={courseData.modules} />
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            <AssessmentCard />
            <DownloadableMaterials materials={courseData.materials} />
            <ProgressCard
              completion={courseData.progress.completion}
              lessonsCompleted={courseData.progress.lessonsCompleted}
              lessonsRemaining={courseData.progress.lessonsRemaining}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
